import styled from "styled-components";

export const StyledGameBoard = styled.div`
    width: 70.2em;
    height: 30.2em;
    background: #9bbc0f;
    position: relative;
    display: grid;
`;